import { WorkingHour } from 'interfaces/clinicSchedule';

interface LunchBreak {
  mon: WorkingHour[];
  tue: WorkingHour[];
  wed: WorkingHour[];
  thu: WorkingHour[];
  fri: WorkingHour[];
  sat: WorkingHour[];
  sun: WorkingHour[];
}

export interface LunchBreakItem {
  day: string;
  startFirst: string | null;
  endFirst: string | null;
  startSecond: string | null;
  endSecond: string | null;
}

export const convertLunchBreaks = (time: WorkingHour[]) => {
  if (time.length === 0) {
    return {
      startFirst: null,
      endFirst: null,
      startSecond: null,
      endSecond: null,
    };
  }

  if (time.length === 1) {
    const { start: startFirst, end: endFirst } = time[0];

    return {
      startFirst,
      endFirst,
      startSecond: null,
      endSecond: null,
    };
  }

  const { start: startFirst, end: endFirst } = time[0];
  const { start: startSecond, end: endSecond } = time[1];

  return {
    startFirst,
    endFirst,
    startSecond,
    endSecond,
  };
};

const normalizeEventBreak = (lunchBreak: LunchBreak) => {
  const normalizeData = Object.entries(lunchBreak);

  const timeSlots = normalizeData.map((data) => {
    const [day, time] = data;

    const result = convertLunchBreaks(time);

    return { ...result, day };
  });

  const sun = timeSlots.pop()!;
  timeSlots.unshift(sun);

  return timeSlots as LunchBreakItem[];
};

export default normalizeEventBreak;
